import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

const couponsAPI = API('/api/coupons.v2', { type: 'rest' });

export default (promoCode: $TSFixMe) => {
  const uri = new URI();
  uri.addQueryParam('action', 'redeemPromoCode');
  uri.addQueryParam('code', promoCode);

  return Q(couponsAPI.post(uri.toString()));
};
